import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import classNames from "classnames";
const BaseLayoutComponent = (props) => {
    const { header, sidebar, children } = props;
    return _jsxs("div", { className: classNames("uxpcore_baselayout__container", {
            'uxpcore_baselayout__container--expandedsidebar': header.expandedSidebar
        }), children: [_jsx("div", { className: "uxpcore_baselayout__header", children: _jsx(Header, Object.assign({}, header)) }), _jsxs("div", { className: classNames("uxpcore_baselayout__body"), children: [_jsx("div", { className: "uxpcore_baselayout__sidebar", children: _jsx(Sidebar, Object.assign({}, sidebar, { expandedSidebar: header.expandedSidebar })) }), _jsx("div", { className: classNames("uxpcore_baselayout__content", {
                            'uxpcore_baselayout__content--expanded-sidebar': header.expandedSidebar
                        }), children: children })] }), _jsx("div", { className: "uxpcore_baselayout__footer" })] });
};
export const BaseLayout = memo(BaseLayoutComponent);
